import React, { useEffect, useState, useImperativeHandle } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import { styled } from "@mui/material/styles";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import InformationTooltip from "components/CustomTooltips/InformationTooltip.js";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import InputAdornment from "@material-ui/core/InputAdornment";
import Icon from "@material-ui/core/Icon";
import Face from "@material-ui/icons/Face";

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import CustomInput from "components/CustomInput/CustomOutlinedInput.js";
import CustomDatePicker from "components/CustomDatePicker/CustomDatePicker.js";
import CustomSelect from "components/CustomSelect/CustomSelect.js";
import CustomDialog from "components/CustomDialog/CustomDialog.js";
import PriceCard from "components/CardComponents/PriceCard";
import CustomToogle from "components/CustomToogle/CustomToogle.js";
import Button from "components/CustomButtons/CustomButton";
import AccidentIcon from "components/CustomIcons/Accident";
import LegalIcon from "components/CustomIcons/Legal";
import TheftIcon from "components/CustomIcons/Theft";
import FormControl from "@material-ui/core/FormControl";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CustomAlerts from "components/Alerts/CustomAlerts";
import StepperComponent from "components/Stepper/StepperComponent";

import styles from "assets/jss/material-dashboard-pro-react/views/loginPageStyle.js";
import stylePrincipal from "assets/jss/material-dashboard-pro-react/components/principalStyle.js";
import DriveEtaIcon from "@material-ui/icons/DriveEta";

import Accordion from "@mui/material/Accordion";
import AccordionActions from "@mui/material/AccordionActions";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";

import AccordionCoverages from "components/AccordionCoverages/AccordionCoverages";
import AccordionCoveragesAgent from "components/AccordionCoveragesAgent/AccordionCoveragesAgent";

import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { getRatesRedesign } from "views/Services/OrdersService";
import {
  formatNumber,
  fixDaysMonths,
  currentDateEffective,
  addDays,
  getDaysFromDates,
  formatDateToEffectiveAndExpiration,
  validValueCoverage,
  getUTCDate,
  isAgent,
} from "components/Utils/utils.js";
import { useTranslation } from "react-i18next";
import { Grid } from "@material-ui/core";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));
const useStylesPrincipal = makeStyles(stylePrincipal);
const useStyles = makeStyles(styles);
let current_date = new Date();

const Step1 = React.forwardRef((props, ref) => {
  const { t, i18n } = useTranslation();
  useImperativeHandle(ref, () => ({
    sendStepData,
  }));
  const sendStepData = (type) => {
    submitAction(vehicleData, coverages, resultRates, type);
  };
  let USDollar = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  });
  const { isSmall, submitAction, isLogged, agencyData } = props;
  const routeParams = useParams();
  const { userId, token, type } = routeParams;
  const dispatch = useDispatch();
  const [data, setData] = useState(null);
  const [open, setOpen] = useState(false);
  const [isCompleted, setIsCompleted] = useState(false);
  const classesPrincipal = useStylesPrincipal();
  const [toastMessage, setToastMessage] = useState(false);
  const [refreshQuote, setRefreshQuote] = useState(false);
  const [oneClicValidate, setOneClicValidate] = useState(false);
  const [oneClickLogin, setOneClickLogin] = useState(false);
  const [validDate, setValidDate] = useState(1);
  const [messageToast, setMessageToast] = useState("");
  const [producerCode, setProducerCode] = useState(null);
  const [seePassword, setSeePassword] = useState(false);
  const [loginCredentials, setLoginCredentials] = useState({
    login: "",
    password: "",
  });
  const [sended, setSended] = useState(false);
  const classes = useStyles();
  const [vehicleData, setVehicleData] = useState({
    vehtype: 1,
    agent: 441,
    fullCoverage: "yes",
  });
  const [valores, setValores] = useState([]);
  const [gettingQuote, setGettingQuote] = useState(false);
  const [vehTypeState, setVehTypeState] = useState("error");
  const trailerTypes = [
    { id: 1, name: "Trailer" },
    { id: 2, name: "Boat" },
    { id: 3, name: "Other" },
    { id: 4, name: "ATV/UTV" },
  ];
  const daysOptions = [
    { value: 1, label: t("daysOptions.1day") },
    { value: 2, label: t("daysOptions.2days") },
    { value: 3, label: t("daysOptions.3days") },
    { value: 4, label: t("daysOptions.4days") },
    { value: 5, label: t("daysOptions.5days") },
    { value: 6, label: t("daysOptions.6days") },
    { value: 7, label: t("daysOptions.7days") },
    { value: 8, label: t("daysOptions.8days") },
    { value: 9, label: t("daysOptions.9days") },
    { value: 10, label: t("daysOptions.10days") },
    { value: 11, label: t("daysOptions.11days") },
    { value: 12, label: t("daysOptions.12days") },
    { value: 13, label: t("daysOptions.13days") },
    { value: 14, label: t("daysOptions.14days") },
    { value: 15, label: t("daysOptions.15days") },
    { value: 16, label: t("daysOptions.16days") },
    { value: 17, label: t("daysOptions.17days") },
    { value: 18, label: t("daysOptions.18days") },
    { value: 19, label: t("daysOptions.19days") },
    { value: 20, label: t("daysOptions.20days") },
    { value: 21, label: t("daysOptions.21days") },
    { value: 22, label: t("daysOptions.22days") },
    { value: 23, label: t("daysOptions.23days") },
    { value: 24, label: t("daysOptions.24days") },
    { value: 25, label: t("daysOptions.25days") },
    { value: 26, label: t("daysOptions.26days") },
    { value: 27, label: t("daysOptions.27days") },
    { value: 28, label: t("daysOptions.28days") },
    { value: 29, label: t("daysOptions.29days") },
    { value: 30, label: t("daysOptions.30days") },
    { value: 90, label: t("daysOptions.90days") },
    { value: 182, label: t("daysOptions.6months") },
    { value: 365, label: t("daysOptions.1year") },
  ];
  const [coverages, setCoverages] = useState({
    agencyfeequote: "0",
    csllimit: "500000",
    excessliab: "150000",
    country: 0,
    policy_type: 1,
    medicallimit: "5000",
    damageded: 2,
    theftded: 5,
    vehtype: 1,
    year_vehicle: 2025,
    specialdiscount: 1,
    effectivedate: "",
    bordercross: 2,
    gapcoverage: "no",
    premierepackage: true,
    fixeddeductible: true,
    policycaravan: false,
    roadside: true,
    physical_damage: true,
    theft: true,
    legalaid: true,
    hdiautoguard: false,
    accessories_and_safety: false,
    ter_ext: false,
  });
  const [resultRates, setResultRates] = useState({});

  useEffect(() => {
    if (props.data) {
      setData(props.data);
      setValuesForTypeVehicle(1, {});
    }
    if (props.producerCode) {
      setProducerCode(props.producerCode);
    }
    if (props.vehicleData) {
      console.log(props.vehicleData);
      setVehicleData(props.vehicleData);
      validateComplete(props.vehicleData);
    }
    if (props.coverages) {
      setCoverages(props.coverages);
    }
  }, [props]);

  useEffect(() => {
    if (type === "oneClickLogin") {
      setOneClickLogin(true);
    }

    if (window.location.href.includes("checkTokenOneClick")) {
      setOneClicValidate(true);
      validateToken();
    }
  }, [dispatch]);

  const handleSubmit = async (event) => {
    getQuoteRates(coverages, vehicleData);
  };
  const handleSubmitStep = async (event) => {
    submitAction(vehicleData, coverages, resultRates);
  };

  const setAgencyList = (agencies) => {
    const indexOnline = agencies.findIndex(
      (obj) => obj.producer_code === "80000"
    );
    const newOrderAgencies = [
      agencies[indexOnline],
      ...agencies.filter((_, i) => i !== indexOnline),
    ];
    return newOrderAgencies.map((item) => ({
      value: item.id,
      label:
        item.producer_code == 80000
          ? item.agency_name
          : `${item.short_name} ${item.city}`,
    }));
  };
  const getAgentName = () => {
    return `${agencyData?.agency_name || ""}`;
  };

  const handleFormChange = (e) => {
    const valor = e.target.value;
    let vehData = { ...vehicleData };
    let coveragesData = { ...coverages };

    vehData[e.target.name] = valor;
    const sendedData = {};
    if (e.target.name === "days") {
      vehData.selectedDays = valor;
    }
    if (e.target.name === "startDate" || e.target.name === "days") {
      const valueStartDate =
        e.target.name === "startDate" ? valor : vehicleData.startDate;
      const valueDays = e.target.name === "days" ? valor : vehicleData.days;
      if (e.target.name === "days") {
        coveragesData.policy_type = 1;
        if (valor > 5 && valor <= 30) {
          coveragesData.policy_type = 2;
        }
        if (valor > 30) {
          coveragesData.policy_type = 3;
        }
      }
      let expirationData = addDays(valueDays, "effectivedate", {
        effectivedate: valueStartDate,
      });
      let formatValueDate = formatDateToEffectiveAndExpiration(
        valueStartDate,
        "quote"
      );
      coveragesData.effectivedate = formatValueDate.date;
      coveragesData.startDate = valueStartDate;
      coveragesData.expirationdate = expirationData.expirationDate.date;
      let formatValueEndDate = formatDateToEffectiveAndExpiration(
        expirationData.expirationDate.date,
        "quote"
      );
      coveragesData.endDate = formatValueEndDate.dateComponent;
      validateDateAndTime(coveragesData.startDate);
      setCoverages(coveragesData);
    }
    if (e.target.name === "vehtype" || e.target.name === "year_vehicle") {
      if (e.target.name === "vehtype") {
        sendedData.vehtype = valor;
        setVehTypeState("success");
        vehData.vehicle_type_id = valor;
        vehData.year_vehicle = vehicleData.year_vehicle;
        vehData.year_model = vehicleData.year_vehicle;
        vehData.type_name = e.nativeEvent.target.textContent;
      } else {
        vehData.vehtype = vehicleData.vehtype;
        vehData.vehicle_type_id = vehicleData.vehtype;
        vehData.year_vehicle = valor;
        setYearState("success");
      }
      setValuesForTypeVehicle(valor, vehData);
    } else if (e.target.name === "make_vehicle" && showSelectMake) {
      vehData.vehtype = vehicleData.vehtype;
      vehData.make_vehicle = valor;
      vehData.makeId = valor;
      setMakeState("success");
      getModelsData(sendedData);
    }
    if (e.target.name === "startTime") {
      coveragesData.timeset = valor;
      coveragesData.startTime = valor;
      setCoverages(coveragesData);
    }
    if (e.target.name === "meridian") {
      coveragesData.meridian = valor;
      setCoverages(coveragesData);
    }
    if (e.target.name === "total_value_vehicle") {
      vehData.total_value = valor;
    }
    if (e.target.name === "total_value_trailer") {
      vehData.towingUnits = valor == -1 ? "no" : "yes";
      vehData.towed_total_value_vehicle = valor;
      vehData.value_trailer = valor;
    }
    if (e.target.name === "year_vehicle") {
      vehData.year_model = e.nativeEvent.target.textContent;
    }
    if (e.target.name === "borderCrossing") {
      let timeZoneList = {
        1: 12,
        2: 8,
        3: 17,
        4: 33,
        5: 12,
        6: 33,
      };
      coveragesData.timezone = timeZoneList[e.target.value];
      coveragesData.bordercross = e.target.value;
      setCoverages(coveragesData);
    }
    if (e.target.name === "make_vehicle") {
      vehData.make_name = ["1", "5"].includes(vehData.vehtype)
        ? e.nativeEvent.target.textContent
        : valor;
      vehData.makeId = valor;
    }
    if (e.target.name === "model_vehicle") {
      vehData.model_name = ["1", "5"].includes(vehData.vehtype)
        ? e.nativeEvent.target.textContent
        : valor;
      vehData.modelId = valor;
    }
    if (e.target.name === "value") {
      setValueState("success");
      vehData.value = valor;
    }
    if (e.target.name === "insurancepolnumber") {
      setFullCoverageState("success");
      vehData.insurancepolnumber = valor;
      if (valor == "No") {
        vehData.value = "0";
        formatValueField(0);
      } else {
        setValuesForTypeVehicle(1, vehData);
      }
    }
    if (e.target.name === "endDate") {
      const initDate = new Date(vehData.startDate);
      const endDate = new Date(vehData.endDate);
      const diffTime = Math.abs(endDate - initDate);
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      vehData.days = diffDays;
      vehData.selectedDays = diffDays;
      coveragesData.endDate = valor;
      setCoverages(coveragesData);
    }
    setVehicleData(vehData);
    validateComplete(vehData);
  };

  const handleCoveragesChange = (e) => {
    const valor = e.target.value;
    let coveragesData = { ...coverages };
    coveragesData[e.target.name] = valor;
    if (e.target.name === "csllimit") {
      coveragesData.premierepackage = valor == "50000" ? false : true;
    }
    if (e.target.name === "roadside") {
      coveragesData.roadside = valor === "yes" ? true : false;
    }
    setCoverages(coveragesData);
    getQuoteRates(coveragesData, vehicleData);
  };
  const validateComplete = (data) => {
    let reqProperties = [
      "borderCrossing",
      "total_value_vehicle",
      "vehtype",
      "days",
      "total_value_trailer",
    ];
    if (localStorage.getItem("userToken") === null) {
      reqProperties.push("agent");
    }
    const allPropertiesValid = reqProperties.every((prop) => {
      return (
        data[prop] !== undefined && data[prop] !== null && data[prop] !== ""
      );
    });
    setIsCompleted(allPropertiesValid);
  };

  const setValuesForTypeVehicle = (type, vehData) => {
    let limitValue = 300000;
    type = parseInt(type);
    if ([1, 7, 13].includes(type)) {
      limitValue = 100000;
    }
    if (type == 5) {
      limitValue = 50000;
    }
    if (type == 11) {
      limitValue = 40000;
    }
    if (
      [10, 12].includes(type) ||
      current_date.getFullYear() - vehData.year_vehicle > 25
    ) {
      limitValue = 0;
    }
    formatValueField(limitValue);
  };

  const formatValueField = (limitValue) => {
    if (limitValue == 0) {
      let vehicleDataToEdit = { ...vehicleData };
      vehicleDataToEdit.value = 0;
      setVehicleData(vehicleDataToEdit);
    }
    const arreglov = [];
    for (let index = 0; index <= limitValue; index += 1000) {
      if (index === 0) {
        arreglov.push({ value: index, traduccion: "$0 - Liability only" });
      } else {
        index >= 3000 &&
          arreglov.push({ value: index, traduccion: USDollar.format(index) });
      }
    }
    setValores(arreglov);
  };
  const today = new Date().toISOString().split("T")[0];
  const futureDate = new Date();
  futureDate.setDate(futureDate.getDate() + 60);
  const sixtyDaysLater = futureDate.toISOString().split("T")[0];
  const timezonesDateList = {
    8: "America/Los_Angeles",
    12: "America/Denver",
    17: "America/Mexico_City",
    33: "America/Chicago",
  };
  const validateDateAndTime = (startDate) => {
    const expDate =
      typeof coverages.endDate !== "undefined"
        ? new Date(coverages.endDate)
        : futureDate;
    const timezoneId =
      typeof timezone !== "undefined" ? timezone : coverages.timezone;

    if (!startDate) return false;
    const selectedDate = new Date(startDate);
    const actualDate = new Date();
    const optionsCurrentDate = {
      timeZone: timezonesDateList[timezoneId],
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    };
    const currentDate = new Date(
      actualDate.toLocaleString("en-EN", optionsCurrentDate)
    );

    if (selectedDate >= currentDate && selectedDate < expDate) {
      setValidDate(1); // Fecha válida
    } else if (selectedDate < currentDate) {
      setValidDate(0); // Fecha en el pasado
    } else if (selectedDate > futureDate) {
      setValidDate(2); // Fecha fuera del rango futuro
    }
  };

  const getQuoteRates = async (coveragesData, vehicle) => {
    let valueVehicle =
      typeof vehicle.total_value_vehicle != "undefined"
        ? parseInt(vehicle.total_value_vehicle || 0)
        : 0;
    let valueTrailer =
      typeof vehicle.total_value_trailer != "undefined"
        ? parseInt(
            vehicle.total_value_trailer > 0 ? vehicle.total_value_trailer : 0
          )
        : 0;
    let valueOther =
      typeof vehicle.total_value_other != "undefined"
        ? parseInt(
            vehicle.total_value_other > 0 ? vehicle.total_value_other : 0
          )
        : 0;
    let totalValue = valueVehicle + valueTrailer + valueOther;
    if (data) {
      let stringRates = {
        csl: coveragesData.csllimit,
        excessliab: coveragesData.excessliab,
        value: totalValue,
        days: vehicle.days,
        country: data.data_customer?.country_id,
        policy_type: coveragesData.policy_type,
        medicallimit: coveragesData.medicallimit,
        damageded: 2,
        theftded: 5,
        vehtype: vehicle.vehtype,
        year_vehicle: data.selectedVehicle?.year_model,
        specialdiscount: 1,
        hasFullCoverage: vehicle.fullCoverage,
        agency_fee: coveragesData.agency_fee,
        effectivedate: coveragesData.effectivedate,
        vehicle_type_model: "",
        bordercross: vehicle.borderCrossing,
        agency: vehicle.agent,
        gapcoverage: coveragesData.gapcoverage == "no" ? false : true,
        premierepackage: coveragesData.premierepackage,
        fixeddeductible: coveragesData.fixeddeductible,
        policycaravan: false,
        roadside: coveragesData.roadside,
        physical_damage: coveragesData.physical_damage,
        theft: coveragesData.theft,
        legalaid: coveragesData.legalaid,
        hdiautoguard: false,
        accessories_and_safety: false,
        ter_ext: false,
      };

      if (typeof data?.selectedVehicle?.trailer != "undefined") {
        stringRates.withtrailer =
          data?.selectedVehicle?.trailer != "0" ? true : false;
      }
      const resultSubmit = await dispatch(getRatesRedesign(stringRates));
      if (resultSubmit.payload.result) {
        setResultRates(resultSubmit.payload.data);
        if (!gettingQuote) {
          setGettingQuote(true);
        }
      } else {
        let mensaje = "\n";
        for (const key in resultSubmit.payload.message) {
          mensaje += "\u2B24" + " " + resultSubmit.payload.message[key] + "\n";
        }
      }
    }
  };

  const checkSelectedQuote = (days) => {
    return vehicleData.days === parseInt(days) ? "yellow" : "gray";
  };

  const setDays = (days) => {
    if (
      (vehicleData.days < 90 && parseInt(days) >= 90) ||
      (vehicleData.days < 365 && parseInt(days) >= 365)
    ) {
      setOpen(true);
    }
    let vehicle = { ...vehicleData };
    vehicle.days = parseInt(days);
    setVehicleData(vehicle);
    getQuoteRates(coverages, vehicle);
  };

  return (
    <div>
      {!gettingQuote ? (
        <GridItem xs={12} sm={12} md={12}>
          {open ? (
            <CustomDialog open={true} title={"Edit Quote"}></CustomDialog>
          ) : null}
          <div
            className={`${classesPrincipal.title} ${classesPrincipal.black}`}
          >
            {t("step1.quote.title")}{" "}
            <span
              className={`${classesPrincipal.title} ${classesPrincipal.red}`}
            >
              {t("step1.quote.quote")}{" "}
            </span>
          </div>
          <div
            className={`${classesPrincipal.subTitle} ${classesPrincipal.black}`}
          >
            {t("step1.quote.subTitle")}{" "}
            <span
              className={`${classesPrincipal.subTitle} ${classesPrincipal.green}`}
            >
              {" "}
              {t("step1.quote.greenSubtitle")}{" "}
            </span>
          </div>

          <GridContainer style={{ marginTop: "20px" }}>
            <GridItem xs={12} sm={12} md={12}>
              {validDate === 2 && coverages.startDate ? (
                <GridContainer>
                  <GridItem
                    style={{ marginTop: "30px", marginBottom: "20px" }}
                    xs={12}
                    sm={12}
                    md={12}
                  >
                    <CustomAlerts
                      title={""}
                      text={t("step4.dateAlert2")}
                      variant="dangerOutlined"
                      icon="warning_amber"
                      severity="error"
                    />
                  </GridItem>
                </GridContainer>
              ) : null}
              {producerCode && (
                <GridContainer style={{ marginBottom: "30px" }}>
                  <GridItem
                    onClick={() => props.setAlertAgency(true)}
                    xs={12}
                    sm={12}
                    md={4}
                  >
                    <span
                      className={`${classesPrincipal.subTitle} ${classesPrincipal.green}`}
                      style={{ cursor: "pointer" }}
                    >
                      {getAgentName(data.catalogs.agencies)}
                    </span>
                  </GridItem>
                </GridContainer>
              )}
              <GridContainer>
                <GridItem xs={12} sm={12} md={4}>
                  <CustomInput
                    labelText={t("step4.policyStartDate")}
                    error={!loginCredentials.login && sended ? true : null}
                    formControlProps={{
                      fullWidth: true,
                      className: classes.customFormControlClasses,
                    }}
                    min={today}
                    inputProps={{
                      required: true,
                      type: "date",
                      name: "startDate",
                      id: "startDateStep1",
                      value: coverages.startDate,
                      onChange: handleFormChange,
                      max: sixtyDaysLater,
                      //min: today,
                    }}
                  />
                </GridItem>
                {isAgent && (
                  <GridItem xs={12} sm={12} md={4}>
                    <CustomInput
                      labelText={t("step4.policyEndDate")}
                      error={!loginCredentials.login && sended ? true : null}
                      formControlProps={{
                        fullWidth: true,
                        className: classes.customFormControlClasses,
                      }}
                      min={today}
                      inputProps={{
                        required: true,
                        type: "date",
                        name: "endDate",
                        id: "endDateStep1",
                        value: coverages.endDate,
                        onChange: handleFormChange,
                        max: sixtyDaysLater,
                        //min: today,
                      }}
                    />
                  </GridItem>
                )}
              </GridContainer>

              <GridContainer>
                <GridItem xs={5} sm={5} md={3}>
                  <CustomSelect
                    labelText={t("step1.quote.daysOfCoverage")}
                    menuItems={daysOptions}
                    error={!loginCredentials.login && sended ? true : null}
                    formControlProps={{
                      fullWidth: true,
                      className: classes.customFormControlClasses,
                    }}
                    placeholder={t("step1.quote.daysPlaceholder")}
                    name="days"
                    information={"Tooltip Text"}
                    value={vehicleData.days}
                    onChange={(e) => handleFormChange(e)}
                    inputProps={{
                      required: true,
                      name: "days",
                      id: "daysStep1",
                      value: vehicleData.days
                        ? vehicleData.days
                        : "placeholder",
                      onChange: handleFormChange,
                    }}
                  />
                </GridItem>
                <GridItem xs={8} sm={8} md={3}>
                  <CustomSelect
                    labelText={t("step1.quote.borderCrossing")}
                    placeholder={t("step1.quote.borderCrossing")}
                    menuItems={
                      data?.catalogs
                        ? data.catalogs.borderCrossing.map((item) => ({
                            value: item.id,
                            label: item.name,
                          }))
                        : []
                    }
                    error={!loginCredentials.login && sended ? true : null}
                    formControlProps={{
                      fullWidth: true,
                      className: classes.customFormControlClasses,
                    }}
                    name="borderCrossing"
                    value={vehicleData.borderCrossing}
                    onChange={(e) => handleFormChange(e)}
                    inputProps={{
                      required: true,
                      name: "borderCrossing",
                      id: "borderCrossingStep1",
                      value: vehicleData.borderCrossing
                        ? vehicleData.borderCrossing
                        : "placeholder",
                      onChange: handleFormChange,
                    }}
                  />
                </GridItem>
              </GridContainer>
              {isAgent && (
                <GridContainer>
                  <GridItem xs={8} sm={8} md={3}>
                    <CustomSelect
                      labelText={t("step4.startTime")}
                      menuItems={[
                        { value: "12:00", label: "12:00" },
                        { value: "12:30", label: "12:30" },
                        { value: "1:00", label: "1:00" },
                        { value: "1:30", label: "1:30" },
                        { value: "2:00", label: "2:00" },
                        { value: "2:30", label: "2:30" },
                        { value: "3:00", label: "3:00" },
                        { value: "3:30", label: "3:30" },
                        { value: "4:00", label: "4:00" },
                        { value: "4:30", label: "4:30" },
                        { value: "5:00", label: "5:00" },
                        { value: "5:30", label: "5:30" },
                        { value: "6:00", label: "6:00" },
                        { value: "6:30", label: "6:30" },
                        { value: "7:00", label: "7:00" },
                        { value: "7:30", label: "7:30" },
                        { value: "8:00", label: "8:00" },
                        { value: "8:30", label: "8:30" },
                        { value: "9:00", label: "9:00" },
                        { value: "9:30", label: "9:30" },
                        { value: "10:00", label: "10:00" },
                        { value: "10:30", label: "10:30" },
                        { value: "11:00", label: "11:00" },
                        { value: "11:30", label: "11:30" },
                      ]}
                      error={!loginCredentials.login && sended ? true : null}
                      formControlProps={{
                        fullWidth: true,
                        className: classes.customFormControlClasses,
                      }}
                      name="startTime"
                      inputProps={{
                        required: true,
                        name: "startTime",
                        id: "startTimeStep4",
                        value: coverages.timeset,
                        onChange: handleFormChange,
                      }}
                    />
                  </GridItem>
                  <GridItem xs={6} sm={6} md={2}>
                    <CustomToogle
                      helperText={null}
                      items={[
                        { value: "AM", label: "AM" },
                        { value: "PM", label: "PM" },
                      ]}
                      error={!loginCredentials.login && sended ? true : null}
                      formControlProps={{
                        fullWidth: true,
                        className: classes.customFormControlClasses,
                      }}
                      style={{ marginTop: "-20px" }}
                      name="meridian"
                      onChange={(e) => handleFormChange(e)}
                      defaultValue={coverages.meridian}
                      inline={true}
                      inputProps={{
                        required: true,
                        name: "meridian",
                        id: "meridianStep1",
                        value: coverages.meridian,
                        onChange: handleFormChange,
                      }}
                    />
                  </GridItem>
                </GridContainer>
              )}
              <GridContainer>
                <GridItem xs={8} sm={8} md={6}>
                  <CustomSelect
                    labelText={t("step1.quote.vehicleType")}
                    menuItems={
                      data?.catalogs
                        ? data.catalogs.vehicle_types.map((item) => ({
                            value: item.id,
                            label: item.name,
                            icon: item.icon,
                          }))
                        : []
                    }
                    error={!loginCredentials.login && sended ? true : null}
                    formControlProps={{
                      fullWidth: true,
                      className: classes.customFormControlClasses,
                    }}
                    name="vehtype"
                    onChange={(e) => handleFormChange(e)}
                    inputProps={{
                      required: true,
                      name: "vehtype",
                      id: "vehtypeStep1",
                      value: vehicleData.vehtype,
                      onChange: handleFormChange,
                    }}
                  />
                </GridItem>
              </GridContainer>
              <GridContainer>
                <GridItem xs={6} sm={6} md={4}>
                  <CustomSelect
                    labelText={t("step1.quote.vehicleValue")}
                    placeholder={t("step1.quote.actualCash")}
                    menuItems={
                      valores
                        ? valores.map((item) => ({
                            value: item.value,
                            label: item.traduccion,
                          }))
                        : []
                    }
                    information={
                      <div
                        dangerouslySetInnerHTML={{
                          __html: t("step1.quote.valueVehicleInfo"),
                        }}
                      />
                    }
                    formControlProps={{
                      fullWidth: true,
                      className: classes.customFormControlClasses,
                    }}
                    name="login"
                    onChange={(e) => handleFormChange(e)}
                    inputProps={{
                      required: true,
                      name: "total_value_vehicle",
                      id: "total_value_vehicleStep1",
                      value:
                        vehicleData.total_value_vehicle != null
                          ? vehicleData.total_value_vehicle
                          : "placeholder",
                      onChange: handleFormChange,
                    }}
                  />
                </GridItem>
              </GridContainer>
              <GridContainer>
                <GridItem xs={12} sm={12} md={12}>
                  <CustomToogle
                    labelText={t("step3.labels.fullCoverage")}
                    items={[
                      { value: "yes", label: t("step3.options.yes") },
                      { value: "no", label: t("step3.options.no") },
                    ]}
                    error={!loginCredentials.login && sended ? true : null}
                    formControlProps={{
                      fullWidth: true,
                      className: classes.customFormControlClasses,
                    }}
                    name="fullCoverage"
                    defaultValue={vehicleData.fullCoverage || "yes"}
                    onChange={(e) => handleFormChange(e)}
                    inputProps={{
                      required: true,
                      name: "fullCoverage",
                      id: "fullCoverageStep1",
                      value: vehicleData.fullCoverage,
                      onChange: handleFormChange,
                    }}
                  />
                </GridItem>
              </GridContainer>
              {vehicleData.vehtype !== "11" && (
                <GridContainer>
                  <GridItem xs={6} sm={6} md={4}>
                    <CustomSelect
                      labelText={t("step1.quote.towedUnitsValue")}
                      information={
                        <div
                          dangerouslySetInnerHTML={{
                            __html: t("step1.quote.towedUnitsInfo"),
                          }}
                        />
                      }
                      menuItems={
                        valores
                          ? [
                              { value: -1, label: t("vehicles.noTowedUnits") },
                              ...valores.map((item) => ({
                                value: item.value,
                                label: item.traduccion,
                              })),
                            ]
                          : [{ value: -1, label: t("vehicles.noTowedUnits") }]
                      }
                      error={!loginCredentials.login && sended ? true : null}
                      formControlProps={{
                        fullWidth: true,
                        className: classes.customFormControlClasses,
                      }}
                      onChange={(e) => handleFormChange(e)}
                      inputProps={{
                        name: "total_value_trailer",
                        id: "total_value_trailerStep1",
                        required: true,
                        value: ![-1, "", null].includes(
                          vehicleData.total_value_trailer
                        )
                          ? vehicleData.total_value_trailer
                          : isAgent && vehicleData.total_value_trailer === ""
                          ? ""
                          : -1,

                        onChange: handleFormChange,
                      }}
                    />
                  </GridItem>
                </GridContainer>
              )}
              <GridContainer>
                {vehicleData && vehicleData.days && vehicleData.days >= 90 ? (
                  <GridItem xs={12} sm={12} md={8}>
                    <CustomToogle
                      labelText={t("step1.quote.vehicleCoverageSonoraBC")}
                      helperText={null}
                      items={[
                        { value: "yes", label: "Yes" },
                        { value: "no", label: "No" },
                      ]}
                      error={!loginCredentials.login && sended ? true : null}
                      formControlProps={{
                        fullWidth: true,
                        className: classes.customFormControlClasses,
                      }}
                      name="login"
                      onChange={(e) => handleFormChange(e)}
                      inputProps={{
                        required: true,
                        name: "mexcoverage",
                        id: "mexcoverageStep1",
                        value: vehicleData.mexcoverage,
                        onChange: handleFormChange,
                      }}
                    />
                  </GridItem>
                ) : null}
              </GridContainer>
              <GridContainer>
                {vehicleData && vehicleData.days && vehicleData.days > 360 ? (
                  <GridItem xs={12} sm={12} md={6}>
                    <CustomToogle
                      labelText={t("step1.quote.sentriPass")}
                      helperText={null}
                      items={[
                        { value: "yes", label: "Yes" },
                        { value: "no", label: "No" },
                      ]}
                      error={!loginCredentials.login && sended ? true : null}
                      formControlProps={{
                        fullWidth: true,
                        className: classes.customFormControlClasses,
                      }}
                      name="login"
                      onChange={(e) => handleFormChange(e)}
                      defaultValue="no"
                      inputProps={{
                        required: true,
                        name: "sentripass",
                        id: "sentripassStep1",
                        value: vehicleData.sentripass,
                        onChange: handleFormChange,
                      }}
                    />
                  </GridItem>
                ) : null}
              </GridContainer>

              {localStorage.getItem("userToken") === null && !producerCode && (
                <GridContainer>
                  <GridItem xs={6} sm={6} md={4}>
                    <CustomSelect
                      labelText={t("step1.quote.selectAgent")}
                      information={t("step1.quote.selectAgentInfo")}
                      helperText={
                        !loginCredentials.login && sended
                          ? "Vehicle type field is required."
                          : null
                      }
                      menuItems={
                        data?.catalogs
                          ? setAgencyList(data.catalogs.agencies)
                          : []
                      }
                      error={!loginCredentials.login && sended ? true : null}
                      formControlProps={{
                        fullWidth: true,
                        className: classes.customFormControlClasses,
                      }}
                      name="login"
                      onChange={(e) => handleFormChange(e)}
                      inputProps={{
                        required: true,
                        name: "agent",
                        id: "agentStep1",
                        value: vehicleData.agent,
                        onChange: handleFormChange,
                      }}
                    />
                  </GridItem>
                </GridContainer>
              )}
            </GridItem>
            <GridItem xs={12} sm={12} md={12}>
              <GridContainer
                style={{ padding: "40px 0px 40px 0px" }}
                justify={isSmall ? "center" : "left"}
              >
                <GridItem xs={12} sm={12} md={4}>
                  <div style={{ marginTop: "10px" }} className={classes.center}>
                    <Button
                      disabled={!isCompleted}
                      id={isLogged ? "getQuote" : "getQuoteGuest"}
                      type="submit"
                      onClick={() => handleSubmit()}
                      variant="green"
                      block
                    >
                      {t("step1.quote.quoteButton")}
                    </Button>
                  </div>
                </GridItem>
              </GridContainer>
            </GridItem>
          </GridContainer>
        </GridItem>
      ) : (
        <GridItem xs={12} sm={12} md={12}>
          <div
            className={`${classesPrincipal.title} ${classesPrincipal.black}`}
          >
            {t("step1.quotation.title")}
          </div>
          <div
            className={`${classesPrincipal.subTitle} ${classesPrincipal.black}`}
          >
            {t("step1.quotation.subTitle")}
          </div>
          <GridContainer style={{ marginTop: "20px" }}>
            <GridItem xs={12} sm={12} md={12}>
              <GridContainer>
                <GridItem xs={12} sm={12} md={6}>
                  <PriceCard
                    size="medium"
                    edit={true}
                    variant={checkSelectedQuote(resultRates.days1)}
                    text={
                      daysOptions.find((e) => e.value == resultRates.days1)
                        .label
                    }
                    onEdit={() => setOpen(true)}
                    clicked={() => setDays(resultRates.days1)}
                    cost={formatNumber(resultRates.total1)}
                    buy={true}
                    buyEvent={handleSubmitStep}
                  />
                </GridItem>
              </GridContainer>
              {vehicleData.days < 365 ? (
                <>
                  <div
                    className={`${classesPrincipal.subTitle} ${classesPrincipal.black} ${classesPrincipal.font700}`}
                  >
                    {t("step1.quotation.savings")}
                  </div>
                  <div
                    className={`${classesPrincipal.text} ${classesPrincipal.black}`}
                  >
                    {t("step1.quotation.greater")}
                  </div>
                </>
              ) : null}
              <GridContainer style={{ marginTop: "20px" }}>
                {vehicleData.days < 90 ? (
                  <GridItem xs={12} sm={12} md={2}>
                    <PriceCard
                      size="small"
                      edit={false}
                      variant={checkSelectedQuote(resultRates.days4)}
                      clicked={() => setDays(resultRates.days4)}
                      text={t("daysOptions.90days")}
                      cost={formatNumber(resultRates.total4)}
                    />
                  </GridItem>
                ) : null}
                {vehicleData.days < 182 ? (
                  <GridItem xs={12} sm={12} md={2}>
                    <PriceCard
                      size="small"
                      edit={false}
                      variant={checkSelectedQuote(resultRates.days2)}
                      clicked={() => setDays(resultRates.days2)}
                      text={t("daysOptions.6months")}
                      cost={formatNumber(resultRates.total2)}
                    />
                  </GridItem>
                ) : null}
                {vehicleData.days < 365 ? (
                  <GridItem xs={12} sm={12} md={2}>
                    <PriceCard
                      size="small"
                      edit={false}
                      variant={checkSelectedQuote(resultRates.days3)}
                      clicked={() => setDays(resultRates.days3)}
                      text={t("daysOptions.1year")}
                      cost={formatNumber(resultRates.total3)}
                    />
                  </GridItem>
                ) : null}
              </GridContainer>
              {isAgent ? (
                <AccordionCoveragesAgent
                  data={data}
                  coverages={coverages}
                  vehicleData={vehicleData}
                  loginCredentials={loginCredentials}
                  handleFormChange={handleFormChange}
                  sended={sended}
                  handleCoveragesChange={handleCoveragesChange}
                  valores={valores}
                />
              ) : (
                <AccordionCoverages
                  data={data}
                  coverages={coverages}
                  vehicleData={vehicleData}
                  loginCredentials={loginCredentials}
                  handleFormChange={handleFormChange}
                  sended={sended}
                  handleCoveragesChange={handleCoveragesChange}
                  valores={valores}
                />
              )}
            </GridItem>
          </GridContainer>
          <GridContainer style={{ marginTop: "20px" }}>
            <GridItem xs={0} sm={0} md={6}></GridItem>
            <GridItem xs={12} sm={12} md={2}>
              <Button
                id={isLogged ? "continueStep1" : "continueStep1Guest"}
                type="submit"
                onClick={handleSubmitStep}
                variant="green"
                //className={`${classesPrincipal.}`}
                block
              >
                {t("step1.coverages.continue")}
              </Button>
            </GridItem>
          </GridContainer>
        </GridItem>
      )}
      <React.Fragment>
        <BootstrapDialog
          onClose={() => setOpen(false)}
          aria-labelledby="customized-dialog-title"
          open={open}
          fullWidth={true}
          maxWidth={"lg"}
        >
          <DialogTitle
            className={`${classesPrincipal.titleAccordion} ${classesPrincipal.black} ${classesPrincipal.title} ${classesPrincipal.yellowBackground}`}
            sx={{ m: 0, p: 2 }}
            id="customized-dialog-title"
          >
            {t("common.editQuote")}
          </DialogTitle>
          <IconButton
            aria-label="close"
            onClick={() => setOpen(false)}
            sx={(theme) => ({
              position: "absolute",
              right: 8,
              top: 8,
              color: theme.palette.grey[500],
            })}
          ></IconButton>
          <DialogContent dividers>
            <GridItem xs={12} sm={12} md={12}>
              <GridContainer>
                <GridItem xs={5} sm={5} md={3}>
                  <CustomSelect
                    labelText={t("step1.quote.daysOfCoverage")}
                    menuItems={daysOptions}
                    error={!loginCredentials.login && sended ? true : null}
                    formControlProps={{
                      fullWidth: true,
                      className: classes.customFormControlClasses,
                    }}
                    placeholder={t("step1.quote.daysPlaceholder")}
                    name="days"
                    information={"Tooltip Text"}
                    value={vehicleData.days}
                    onChange={(e) => handleFormChange(e)}
                    inputProps={{
                      name: "days",
                      id: "daysStep1",
                      value: vehicleData.days
                        ? vehicleData.days
                        : "placeholder",
                      onChange: handleFormChange,
                    }}
                  />
                </GridItem>
                <GridItem xs={8} sm={8} md={3}>
                  <CustomSelect
                    labelText={t("step1.quote.borderCrossing")}
                    placeholder={t("step1.quote.borderCrossing")}
                    menuItems={
                      data?.catalogs
                        ? data.catalogs.borderCrossing.map((item) => ({
                            value: item.id,
                            label: item.name,
                          }))
                        : []
                    }
                    error={!loginCredentials.login && sended ? true : null}
                    formControlProps={{
                      fullWidth: true,
                      className: classes.customFormControlClasses,
                    }}
                    name="borderCrossing"
                    value={vehicleData.borderCrossing}
                    onChange={(e) => handleFormChange(e)}
                    inputProps={{
                      name: "borderCrossing",
                      id: "borderCrossingStep1",
                      value: vehicleData.borderCrossing
                        ? vehicleData.borderCrossing
                        : "placeholder",
                      onChange: handleFormChange,
                    }}
                  />
                </GridItem>
              </GridContainer>
              <GridContainer>
                <GridItem xs={8} sm={8} md={6}>
                  <CustomSelect
                    labelText={t("step1.quote.vehicleType")}
                    menuItems={
                      data?.catalogs
                        ? data.catalogs.vehicle_types.map((item) => ({
                            value: item.id,
                            label: item.name,
                            icon: item.icon,
                          }))
                        : []
                    }
                    error={!loginCredentials.login && sended ? true : null}
                    formControlProps={{
                      fullWidth: true,
                      className: classes.customFormControlClasses,
                    }}
                    name="vehtype"
                    onChange={(e) => handleFormChange(e)}
                    inputProps={{
                      name: "vehtype",
                      id: "vehtypeStep1",
                      value: vehicleData.vehtype,
                      onChange: handleFormChange,
                    }}
                  />
                </GridItem>
              </GridContainer>
              <GridContainer>
                <GridItem xs={6} sm={6} md={4}>
                  <CustomSelect
                    labelText={t("step1.quote.vehicleValue")}
                    placeholder={t("step1.quote.actualCash")}
                    menuItems={
                      valores
                        ? valores.map((item) => ({
                            value: item.value,
                            label: item.traduccion,
                          }))
                        : []
                    }
                    information={
                      <div
                        dangerouslySetInnerHTML={{
                          __html: t("step1.quote.valueVehicleInfo"),
                        }}
                      />
                    }
                    formControlProps={{
                      fullWidth: true,
                      className: classes.customFormControlClasses,
                    }}
                    name="login"
                    onChange={(e) => handleFormChange(e)}
                    inputProps={{
                      name: "total_value_vehicle",
                      id: "total_value_vehicleStep1",
                      value:
                        vehicleData.total_value_vehicle != null
                          ? vehicleData.total_value_vehicle
                          : "placeholder",
                      onChange: handleFormChange,
                    }}
                  />
                </GridItem>
              </GridContainer>
              {vehicleData.vehtype !== "11" && (
                <GridContainer>
                  <GridItem xs={6} sm={6} md={4}>
                    <CustomSelect
                      labelText={t("step1.quote.towedUnitsValue")}
                      information={
                        <div
                          dangerouslySetInnerHTML={{
                            __html: t("step1.quote.towedUnitsInfo"),
                          }}
                        />
                      }
                      menuItems={
                        valores
                          ? [
                              { value: -1, label: t("vehicles.noTowedUnits") },
                              ...valores.map((item) => ({
                                value: item.value,
                                label: item.traduccion,
                              })),
                            ]
                          : [{ value: -1, label: t("vehicles.noTowedUnits") }]
                      }
                      error={!loginCredentials.login && sended ? true : null}
                      formControlProps={{
                        fullWidth: true,
                        className: classes.customFormControlClasses,
                      }}
                      name="login"
                      onChange={(e) => handleFormChange(e)}
                      inputProps={{
                        name: "total_value_trailer",
                        id: "total_value_trailerStep1",
                        value: vehicleData.total_value_trailer
                          ? vehicleData.total_value_trailer
                          : -1,

                        onChange: handleFormChange,
                      }}
                    />
                  </GridItem>
                </GridContainer>
              )}
              <GridContainer>
                {vehicleData && vehicleData.days && vehicleData.days >= 90 ? (
                  <GridItem xs={12} sm={12} md={8}>
                    <CustomToogle
                      labelText={t("step1.quote.vehicleCoverageSonoraBC")}
                      helperText={null}
                      items={[
                        { value: "yes", label: "Yes" },
                        { value: "no", label: "No" },
                      ]}
                      error={!loginCredentials.login && sended ? true : null}
                      formControlProps={{
                        fullWidth: true,
                        className: classes.customFormControlClasses,
                      }}
                      name="login"
                      onChange={(e) => handleFormChange(e)}
                      inputProps={{
                        required: true,
                        name: "mexcoverage",
                        id: "mexcoverageStep1",
                        value: vehicleData.mexcoverage,
                        onChange: handleFormChange,
                      }}
                    />
                  </GridItem>
                ) : null}
              </GridContainer>
              <GridContainer>
                {vehicleData && vehicleData.days && vehicleData.days > 360 ? (
                  <GridItem xs={12} sm={12} md={6}>
                    <CustomToogle
                      labelText={t("step1.quote.sentriPass")}
                      helperText={null}
                      items={[
                        { value: "yes", label: "Yes" },
                        { value: "no", label: "No" },
                      ]}
                      error={!loginCredentials.login && sended ? true : null}
                      formControlProps={{
                        fullWidth: true,
                        className: classes.customFormControlClasses,
                      }}
                      name="login"
                      onChange={(e) => handleFormChange(e)}
                      defaultValue="no"
                      inputProps={{
                        name: "sentripass",
                        id: "sentripassStep1",
                        value: vehicleData.sentripass,
                        onChange: handleFormChange,
                      }}
                    />
                  </GridItem>
                ) : null}
              </GridContainer>
            </GridItem>
            <GridItem xs={12} sm={12} md={12}>
              <GridContainer
                style={{ padding: "40px 0px 40px 0px" }}
                justify={isSmall ? "center" : "left"}
              >
                <GridItem xs={5} sm={5} md={2}>
                  <div style={{ marginTop: "10px" }} className={classes.center}>
                    <Button
                      disabled={!isCompleted}
                      id={
                        isLogged ? "recalculateStep1" : "recalculateStep1Guest"
                      }
                      type="submit"
                      onClick={() => {
                        setOpen(false);
                        handleSubmit();
                      }}
                      variant="green"
                      block
                    >
                      {t("common.recalculate")}
                    </Button>
                  </div>
                </GridItem>
              </GridContainer>
            </GridItem>
          </DialogContent>
        </BootstrapDialog>
      </React.Fragment>
    </div>
  );
});

Step1.displayName = "Step1";

export default Step1;
